// // export default Home;
// import React from 'react';
// import './Home.css';
// import Arrow from '../../assets/arrow.png';
// import HomeBg from '../../assets/home.png'; // Importation correcte de l'image

// import { useTranslation } from 'react-i18next';

// const Home = () => {
//   const { t } = useTranslation();

//   const handleScrollToService = () => {
//     const section = document.getElementById("service-section");
//     if (section) {
//       const navbarHeight = 100; // Adjust based on your navbar height
//       const yOffset = section.getBoundingClientRect().top + window.scrollY - navbarHeight;

//       window.scrollTo({ top: yOffset, behavior: "smooth" });
//     }
//   };


//   return (
//     <section className="home" id="home" style={{ backgroundImage: `url(${HomeBg})` }}>
//       <div className="homeholder">
//         <div className="homecontainer">
//           <h1>{t('welcome')}</h1>
//           <p>{t('experience')}</p>
//           {/* <a href="/services">
//             {t('discoverOurServices')}
//             <img src={Arrow} alt={t('arrowAltText')} />
//           </a> */}
//           <button className="scroll-button" onClick={handleScrollToService}>
//             {t("discoverOurServices")}
//             <img src={Arrow} alt={t("arrowAltText")} />
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Home;


import React from 'react';
import './Home.css';
import Arrow from '../../assets/arrow.png';
import HomeBg from '../../assets/home.png.jpg'; // Importing the correct background image
import { useTranslation } from 'react-i18next';

const Home = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar"; // Check if the current language is Arabic

  const handleScrollToService = () => {
    const section = document.getElementById("service-section");
    if (section) {
      const navbarHeight = 100; // Adjust based on your navbar height
      const yOffset = section.getBoundingClientRect().top + window.scrollY - navbarHeight;
      window.scrollTo({ top: yOffset, behavior: "smooth" });
    }
  };

  return (
    <section className="home" id="home" style={{ backgroundImage: `url(${HomeBg})` }}>
      <div className="homeholder">
        <div className="homecontainer">
          <h1>{t('welcome')}</h1>
          <p>{t('experience')}</p>
          <button className="scroll-button" onClick={handleScrollToService}>
            {t("discoverOurServices")}
            <img 
              src={Arrow} 
              alt={t("arrowAltText")} 
              style={{ transform: isArabic ? "scaleX(-1)" : "none" }} 
            />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Home;

